package org.teddapp.project.ui.login

import androidx.compose.foundation.background
import androidx.compose.ui.unit.sp
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.teddapp.project.ui.TeddIcon
import org.teddapp.project.ui.TeddIconButton
import org.teddapp.project.ui.TeddLogo
import org.teddapp.project.ui.TeddSpace
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.TeddType

/**
 * Briques de la connexion en mise en page étendue : ce que l'application promet, à gauche
 * du formulaire, et le bandeau d'erreur. Le formulaire lui-même vit dans LoginScreen.kt.
 */

@Composable
internal fun LeftPitch(modifier: Modifier = Modifier) {
    Column(modifier = modifier, verticalArrangement = Arrangement.Center) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
            TeddLogo(size = 28.dp)
            Text("teddApp", style = TeddType.Title2, color = TeddTokens.Ink)
        }
        Spacer(modifier = Modifier.height(TeddSpace.S8))
        Column(modifier = Modifier.widthIn(max = 480.dp), verticalArrangement = Arrangement.spacedBy(TeddSpace.S4)) {
            org.teddapp.project.ui.TeddFitText("Reprends la main sur ta vie.", style = TeddType.DisplayLg, minFontSize = 26.sp, maxLines = 3)
            Text(
                text = "Tes objectifs, tes projets, ton argent, tes habitudes et tes notes, au même endroit.",
                style = TeddType.BodyLg,
                color = TeddTokens.InkMuted,
            )
        }
        Spacer(modifier = Modifier.height(TeddSpace.S8))
        Column(verticalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
            Promise("Tout fonctionne sans réseau.")
            Promise("Tes données restent sur cet appareil.")
            Promise("La synchronisation entre appareils est facultative.")
        }
    }
}

/** Une promesse tenue par l'application, pas un chiffre de vitrine. */
@Composable
private fun Promise(text: String) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
        TeddIcon(name = "check", size = 16.dp, color = TeddTokens.LimeStrong, strokeWidth = 2.dp)
        Text(text, style = TeddType.Body, color = TeddTokens.Ink)
    }
}

@Composable
internal fun ErrorBanner(message: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(TeddTokens.DangerSoft, RoundedCornerShape(TeddTokens.RSm))
            .padding(horizontal = TeddSpace.S3, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
    ) {
        TeddIcon(name = "alert", size = 16.dp, color = TeddTokens.Danger)
        Text(message, color = TeddTokens.Danger, style = TeddType.Caption)
    }
}

@Composable
internal fun ShowHideButton(showPwd: Boolean, onToggle: () -> Unit) {
    TeddIconButton(onClick = onToggle, size = 28.dp) {
        TeddIcon(name = if (showPwd) "eye-off" else "eye", size = 16.dp, color = TeddTokens.InkMuted)
    }
}
